import React from 'react'
import { ButtonLoadingSeeker, ButtonSeeker, IconSeeker } from '@ui-seeker/core'
import { closeDrawer, isFormSubmitLoading, reportFormErrors } from 'Pages/ReportsAlerts/Reports/@signals'
import { useComputed } from '@preact/signals-react'
import { useReportFormSubmit } from 'Pages/ReportsAlerts/Reports/@hooks'


export default function ReportFormDrawerFooter() {

	const isReportFormDrawerValid = useComputed(() => Object.values(reportFormErrors.value).every(e => e))
	useReportFormSubmit()


	return <>
		<ButtonSeeker
			variant="outlined"
			onClick={closeDrawer}
		>
			Cancel
		</ButtonSeeker>
		<ButtonLoadingSeeker
			sx={{ minWidth: 103 }}
			startIcon={<IconSeeker icon="memo-circle-check"/>}
			loading={isFormSubmitLoading.value}
			disabled={!isReportFormDrawerValid.value}
			onClick={() => isFormSubmitLoading.value = true}
		>
			Save
		</ButtonLoadingSeeker>
	</>
}